import { Component, OnInit, Pipe, PipeTransform, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DPAccount } from './dp-account';
import { DPUser } from './dp-user';
import { DPUserService } from './dp-user.service';
import { DPUsers } from './dp-users';
import { DPRole } from './dp-role';
import { ActivatedRoute, Params } from '@angular/router';
import { DPAccountService } from './dp-accounts.service';

import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import 'rxjs/Rx';

import { Overlay } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { DialogRef } from 'ngx-modialog';
import { ToasterService } from 'angular2-toaster/src/toaster.service';


@Component({
  templateUrl: 'dp-users.component.html',

})
export class DPUsersComponent implements OnInit {
  users: DPUser[];
  filteredUsers: DPUser[];

  selectedUser: DPUser;
  addingUser = false;
  errorResponse: any;
  csvaccount: DPAccount;
  roles: DPRole[];
  account: DPAccount;
  navigated = false; // true if navigated here
  accountId: any;
  dialog: any;
  result: any;
  notificationTitle: any;
  notificationContent: any;
  notificationType: any;
  deleting = false;
  userViewType = 'View All';
  sortType = 'Email';
  filterType = 'Select Type';
  filterValue = 'Select Value';
  actionable = true;
  filterValueList = new Array<string>();

  constructor(
    private toasterService: ToasterService,

    private _service: NotificationsService,
    private router: Router,
    private accountService: DPAccountService,
    private userService: DPUserService,
    private route: ActivatedRoute,
    public modal: Modal
  ) { }

  public options = {
    timeOut: 5000,
    lastOnBottom: true,
    clickToClose: true,
    maxLength: 0,
    maxStack: 7,
    showProgressBar: true,
    pauseOnHover: true,
    preventDuplicates: false,
    preventLastDuplicates: 'visible',
    rtl: false,
    animate: 'scale',
    position: ['right', 'bottom']
  };

  download() {
    const a = document.createElement('a');
    document.body.appendChild(a);

    const date = new Date();
    a.download = 'Users for ' + this.account.account_name + ' ' + date.toDateString();
    const csvData = this.ConvertToCSV(this.filteredUsers);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.click();
    window.URL.revokeObjectURL(url);
  }
  ConvertToCSV(objArray: DPUser[]) {
    const array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    const row = 'user_id,user_email,first_name,last_name,mobile_number,ddi_number,skype_id,linkedin,status,logged_in_before,account,user_roles,created_on\r\n';
    const csvHeaders: Array<string> = ['user_id', 'user_email', 'first_name', 'last_name', 'mobile_number', 'ddi_number', 'skype_id', 'linkedin', 'status', 'logged_in_before', 'account', 'user_roles', 'created_on'];
    str += row;
    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let j = 0; j < csvHeaders.length; j++) {
        if (undefined != array[i][csvHeaders[j]]) {
          if (line != '') line += ',';
          if (csvHeaders[j] == 'account') {
            this.csvaccount = array[i][csvHeaders[j]];
            line += this.csvaccount.account_name;
          } else if (csvHeaders[j] == 'user_roles') {
            this.roles = array[i][csvHeaders[j]];
            let rolestring = '';
            for (let x = 0; x < this.roles.length; x++) {
              if (rolestring != '') rolestring += '/';
              rolestring += this.roles[x].role_name;
            }
            line += rolestring;
          } else {
            line += array[i][csvHeaders[j]];
          }
        } else {
          if (line != '') line += ',';
          line += '';
        }
      }
      str += line + '\r\n';
    }
    return str;
  }
  createNotification() {
    switch (this.notificationType) {
      case 'success':
        //this._service.success(this.notificationTitle, this.notificationContent);
        this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
        break;
      case 'error':
        this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
        //this._service.error(this.notificationTitle, this.notificationContent);
        break;
      case 'info':
        this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
        //this._service.info(this.notificationTitle, this.notificationContent);
        break;
    }
  }
  errorHandler(error: any) {
    this.notificationType = 'error';
    this.notificationTitle = 'Error';
    const jsonErrorBody = JSON.parse(error._body);
    this.notificationContent = jsonErrorBody.error.message;
    this.createNotification();
    this.deleting = false;
  }

  getAccount(account_id: number) {
    return this.accountService
      .getAccount(account_id)
      .then(res => this.account = res)
      .catch(error => this.errorHandler(error));
  }

  getUsers(account_id: number) {
    return this.userService
      .getUsers(account_id)
      .then(res => {
        this.users = res.user;
        this.filteredUsers = this.users;
        this.clickViewType('View All');
        this.clickSortType('Email');
      })
      .catch(error => this.errorHandler(error));
  }

  addUser() {
    this.addingUser = true;
    this.selectedUser = null;
  }

  deleteUser(user: DPUser, event: any) {
    this.userService
      .delete(user)
      .then(res => {
        this.users = this.users.filter(u => u !== user);
        this.notificationType = 'success';
        this.notificationTitle = 'Successful';
        this.notificationContent = 'User : ' + user.user_email + ' is deleted';
        this.createNotification();
        this.deleting = false;

        if (this.selectedUser === user) { this.selectedUser = null; }
      })
      .catch(error => this.errorHandler(error));

  }

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.accountId = params['account_id'];
      this.navigated = true;
      localStorage.setItem('accountId', params['account_id']);

    });
    this.getAccount(this.accountId);
    this.getUsers(this.accountId);


  }

  onSelect(user: DPUser) {
    this.selectedUser = user;
    this.addingUser = false;
  }

  gotoDetail(user: DPUser) {
    this.router.navigate(['/demandportal/customer/account/users/userdetail', user.user_id]);
  }

  selectCreateUser() {
    this.router.navigate(['demandportal/customer/account/users/usercreate', this.accountId]);
  }
  goBack() {
    if (this.navigated) {
      event.stopPropagation();
      this.router.navigate(['/demandportal/customer/account', this.account.customer.customer_id]);

    }
  }

  onClickSendEmail(user: DPUser, event: any) {
    event.stopPropagation();
    this.actionable = false;
    this.userService
      .sendUserWelcomeEmail(user.user_id)
      .then(res => {
        user.email_sent = 1;
        this.notificationType = 'success';
        this.notificationTitle = 'Successful';
        this.notificationContent = 'Just sent welcome email to ' + user.user_email;
        this.createNotification();
        this.actionable = true;

      })
      .catch(error => {
        this.errorHandler(error);
        this.actionable = true;
      });
  }
  onClickActivationUser(user: DPUser, event: any) {
    event.stopPropagation();
    const dialogMessage = user.status === 1 ? 'You really want to deactivate this customer?' : 'You really want to activate this customer?';
    this.deleting = true;
    this.dialog = this.modal.confirm()
      .size('sm')
      .isBlocking(false)
      .showClose(false)
      .keyboard(27)
      .body(dialogMessage)
      .okBtn('Yes')
      .cancelBtn('No')
      .open();
    this.processDialogActivation(user, event, this.dialog);
  }
  private processDialogActivation(user: DPUser, event: any, dialog: Promise<DialogRef<any>>) {
    dialog.then((resultPromise) => {
      return resultPromise.result.then((result) => {
        if (user.status == 1) {
          user.status = 0;
        } else {
          user.status = 1;
        }

        this.save(user);
      }, () => {
        this.deleting = false;
        this.result = 'Rejected!';
      });
    });
  }


  onClickSendEmailDialog(user: DPUser, event: any) {
    event.stopPropagation();
    const dialogMessage = 'You really want to send welcome email to this customer?';
    this.deleting = true;
    this.dialog = this.modal.confirm()
      .size('sm')
      .isBlocking(false)
      .showClose(false)
      .keyboard(27)
      .body(dialogMessage)
      .okBtn('Yes')
      .cancelBtn('No')
      .open();
    this.processDialogSendEmail(user, event, this.dialog);
  }
  private processDialogSendEmail(user: DPUser, event: any, dialog: Promise<DialogRef<any>>) {
    dialog.then((resultPromise) => {
      return resultPromise.result.then((result) => {
        this.onClickSendEmail(user, event);
        this.deleting = false;

      }, () => {
        this.deleting = false;
        this.result = 'Rejected!';
      });
    });
  }

  save(user: DPUser) {
    user.email_sent = undefined;
    user.modules = undefined;
    user.notifications = undefined;
    user.settings = undefined;


    this.userService
      .updateUser(user)
      .then(res => {
        this.deleting = false;
        this.getUsers(this.accountId);
      })
      .catch(error => {
        if (user.status == 1) {
          user.status = 0;
        }
        else {
          user.status = 1;
        }
        this.deleting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
      });
  }

  clickSortType(event: any) {
    if (this.sortType == 'Status') {
      this.filteredUsers.sort((leftSide, rightSide): number => {
        if (leftSide.status < rightSide.status) return 1;
        if (leftSide.status > rightSide.status) return -1;
        return 0;
      });
      this.users.sort((leftSide, rightSide): number => {
        if (leftSide.status < rightSide.status) return 1;
        if (leftSide.status > rightSide.status) return -1;
        return 0;
      });
    } else if (this.sortType == 'Email') {
      this.filteredUsers.sort((leftSide, rightSide): number => {
        if (leftSide.user_email.toLowerCase() > rightSide.user_email.toLowerCase()) { return 1; };
        if (leftSide.user_email.toLowerCase() < rightSide.user_email.toLowerCase()) { return -1; };
        return 0;
      });
      this.users.sort((leftSide, rightSide): number => {
        if (leftSide.user_email.toLowerCase() > rightSide.user_email.toLowerCase()) { return 1; };
        if (leftSide.user_email.toLowerCase() < rightSide.user_email.toLowerCase()) { return -1; };
        return 0;
      });
    }
    else if (this.sortType == 'Sent Invite Email') {
      this.filteredUsers.sort((leftSide, rightSide): number => {
        if (leftSide.email_sent < rightSide.email_sent) return 1;
        if (leftSide.email_sent > rightSide.email_sent) return -1;
        return 0;
      });
      this.users.sort((leftSide, rightSide): number => {
        if (leftSide.email_sent < rightSide.email_sent) return 1;
        if (leftSide.email_sent > rightSide.email_sent) return -1;
        return 0;
      });
    }
    else if (this.sortType === 'Last Logged In') {
      this.filteredUsers.sort((leftSide, rightSide): number => {
        if (this.getDateSort(leftSide.last_logged_in_date) < this.getDateSort(rightSide.last_logged_in_date)) { return 1; };
        if (this.getDateSort(leftSide.last_logged_in_date) > this.getDateSort(rightSide.last_logged_in_date)) { return -1; };
        return 0;
      });
      this.users.sort((leftSide, rightSide): number => {
        if (this.getDateSort(leftSide.last_logged_in_date) < this.getDateSort(rightSide.last_logged_in_date)) { return 1; };
        if (this.getDateSort(leftSide.last_logged_in_date) > this.getDateSort(rightSide.last_logged_in_date)) { return -1; };
        return 0;
      });
    }
    else if (this.sortType === 'Created Date') {
      this.filteredUsers.sort((leftSide, rightSide): number => {
        if (this.getDateSort(leftSide.created_on) < this.getDateSort(rightSide.created_on)) { return 1; };
        if (this.getDateSort(leftSide.created_on) > this.getDateSort(rightSide.created_on)) { return -1; };
        return 0;
      });
      this.users.sort((leftSide, rightSide): number => {
        if (this.getDateSort(leftSide.created_on) < this.getDateSort(rightSide.created_on)) { return 1; };
        if (this.getDateSort(leftSide.created_on) > this.getDateSort(rightSide.created_on)) { return -1; };
        return 0;
      });
    }
  }
  getDateSort(date: any) {
    if (date !== undefined) {
      return new Date(date).getTime();
    } else {
      return new Date('2000-01-01').getTime();
    }
  }

  clickViewType(event: any) {
    if (this.userViewType == 'View All') {
      this.filteredUsers = this.users;
    } else if (this.userViewType == 'View Active') {
      this.filteredUsers = this.users.filter(c => c.status == 1);
    } else if (this.userViewType == 'View Inactive') {
      this.filteredUsers = this.users.filter(c => c.status == 0);
    } else {
      this.filteredUsers = this.users.filter(c => c.email_sent == 0);
    }


    this.filterValue = 'Select Value';
    this.filterType = 'Select Type';
    this.filterValueList = new Array<string>();

  }

  clickFilterValue(event: any) {
    if (this.filterValue !== 'Select Value') {
      if (this.filterType === 'Location') {
        if (this.filterValue === 'Unknown') {
          this.filteredUsers = this.users.filter(x => x.location === '' || x.location === undefined);
        } else {
          this.filteredUsers = this.users.filter(x => x.location === this.filterValue);
        }
      } else if (this.filterType === 'Region') {
        if (this.filterValue === 'Unknown') {
          this.filteredUsers = this.users.filter(x => x.region === '' || x.region === undefined);
        } else {
          this.filteredUsers = this.users.filter(x => x.region === this.filterValue);
        }
      } else if (this.filterType === 'Business Unit') {
        if (this.filterValue === 'Unknown') {
          this.filteredUsers = this.users.filter(x => x.business_unit === '' || x.business_unit === undefined);
        } else {
          this.filteredUsers = this.users.filter(x => x.business_unit === this.filterValue);
        }
      } else if (this.filterType === 'Parrot Touch Point') {
        if (this.filterValue === 'Unknown') {
          this.filteredUsers = this.users.filter(x => x.parrot_touch_point === '' || x.parrot_touch_point === undefined);
        } else {
          this.filteredUsers = this.users.filter(x => x.parrot_touch_point === this.filterValue);
        }
      }
      this.userViewType = 'View All';
      this.clickSortType(event);
    }
  }
  clickFilterType(event: any) {
    this.filterValueList = new Array<string>();
    this.filterValue = 'Select Value';
    if (this.filterType === 'Location') {
      this.users.forEach(x => this.filterValueList.includes(x.location) === false && x.location !== '' && x.location !== undefined ? this.filterValueList.push(x.location) : null);
      this.filterValueList.sort((a, b) => {
        if (a > b) { return 1; }
        if (a < b) { return -1; }
        return 0;
      });;
      this.filterValueList.push('Unknown');
    } else if (this.filterType === 'Region') {
      this.users.forEach(x => this.filterValueList.includes(x.region) === false && x.region !== '' && x.region !== undefined ? this.filterValueList.push(x.region) : null);
      this.filterValueList.sort((a, b) => {
        if (a > b) { return 1; }
        if (a < b) { return -1; }
        return 0;
      });;
      this.filterValueList.push('Unknown');
    } else if (this.filterType === 'Business Unit') {
      this.users.forEach(x => this.filterValueList.includes(x.business_unit) === false && x.business_unit !== '' && x.business_unit !== undefined ? this.filterValueList.push(x.business_unit) : null);
      this.filterValueList.sort((a, b) => {
        if (a > b) { return 1; }
        if (a < b) { return -1; }
        return 0;
      });;
      this.filterValueList.push('Unknown');
    } else if (this.filterType === 'Parrot Touch Point') {
      this.users.forEach(x => this.filterValueList.includes(x.parrot_touch_point) === false && x.parrot_touch_point !== '' && x.parrot_touch_point !== undefined ? this.filterValueList.push(x.parrot_touch_point) : null);
      this.filterValueList.sort((a, b) => {
        if (a > b) { return 1; }
        if (a < b) { return -1; }
        return 0;
      });;
      this.filterValueList.push('Unknown');
    } else {
      this.filteredUsers = this.users;
      this.userViewType = 'View All';

    }


  }
}




// WEBPACK FOOTER //
// ./src/app/portalv1/dp-users.component.ts